import React, { useMemo, useState } from 'react';
import Subtitles from '../../helpers/subtitles';

export const usePIPSubtitles = ({
  currentAudioLanguage,
  pipControlsRef,
  videoTagRef,
}) => {
  const [subs, setSubs] = useState(null);
  const modifySubtitles = () => {
    if (navigator.userAgent?.match(/version.*safari/i)) {
      return;
    }
    const subtitles = new Subtitles({
      videoElement: videoTagRef.current,
      language: currentAudioLanguage?.subtitle,
    });
    subtitles.placeAbove(pipControlsRef.current);
    setSubs(subtitles);
  };

  React.useEffect(
    () => {
      if (videoTagRef.current && subs === null) {
        videoTagRef.current.addEventListener('play', function onFirstPlay() {
          if (videoTagRef.current.textTracks.length) {
            modifySubtitles();
            videoTagRef.current?.removeEventListener('play', onFirstPlay);
          }
        });
        return () => {
          subs?.clean();
          setSubs(null);
        };
      }
      return () => {
        subs?.clean();
        setSubs(null);
      };
    },
    [videoTagRef.current],
  );

  React.useEffect(
    () => {
      if (
        !navigator.userAgent?.match(/version.*safari/i) &&
        currentAudioLanguage
      ) {
        if (currentAudioLanguage.subtitle === null) {
          subs?.changeMode('hidden');
        } else if (!subs) {
          modifySubtitles();
        } else {
          subs?.clean();
          subs?.changeMode('showing');
        }
      } else if (navigator.userAgent?.match(/version.*safari/i)) {
        setTimeout(() => {
          [...videoTagRef.current.textTracks].forEach(item => {
            item.mode = 'hidden';
          });
          const correct = [...videoTagRef.current.textTracks].filter(item => {
            return (
              item.language === currentAudioLanguage.subtitle?.toLowerCase() &&
              item.cues !== null
            );
          });
          if (correct.length) {
            correct.forEach(showable => (showable.mode = 'showing'));
          }
        }, 2500);
      }
    },
    [currentAudioLanguage],
  );
};
